module.exports = __webpack_public_path__ + "media/images/logo-ever-factor-footer-1f3963e5147b8b91d130143f42aef0eb.png";